var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "package_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1047_2950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1047_2950)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "package_2_2",
    d: "M14.6667 28.9667V16.7667L4 10.6001V21.3001C4 21.789 4.11667 22.2334 4.35 22.6334C4.58333 23.0334 4.91111 23.3556 5.33333 23.6001L14.6667 28.9667ZM17.3333 28.9667L26.6667 23.6001C27.0889 23.3556 27.4167 23.0334 27.65 22.6334C27.8833 22.2334 28 21.789 28 21.3001V10.6001L17.3333 16.7667V28.9667ZM22.6333 10.6334L26.5667 8.33342L17.3333 3.03341C16.9111 2.78897 16.4667 2.66675 16 2.66675C15.5333 2.66675 15.0889 2.78897 14.6667 3.03341L12.0333 4.53341L22.6333 10.6334ZM16 14.4667L19.9667 12.2001L9.4 6.06675L5.4 8.36675L16 14.4667Z",
    fill: "#70BE8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage2);
export default __webpack_public_path__ + "static/media/package_2.ca00156cabd11e7160db5576dfe479fd.svg";
export { ForwardRef as ReactComponent };